<template>
  <div class="side-munu">
    <div class="logo">
      Issues Dashboard
    </div>
    <mu-divider />
    <mu-list toggle-nested>
      <mu-list-item button :ripple="false" nested :open="open.kinds" @toggle-nested="open[kinds] = true">
        <mu-list-item-action>
          <mu-icon value="filter_list"></mu-icon>
        </mu-list-item-action>
        <mu-list-item-title>Kind</mu-list-item-title>
        <mu-list-item-action>
          <mu-icon class="toggle-icon" size="24" value="keyboard_arrow_down"></mu-icon>
        </mu-list-item-action>

        <mu-list-item button :ripple="false" @click="handleToggle('kinds', 'bug')" slot="nested">
          <mu-list-item-title>Bug</mu-list-item-title>
          <mu-list-item-action>
            <mu-switch v-model="kinds.bug" readonly></mu-switch>
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item button :ripple="false" @click="handleToggle('kinds', 'enhancement')" slot="nested">
          <mu-list-item-title>Enhancement</mu-list-item-title>
          <mu-list-item-action>
            <mu-switch v-model="kinds.enhancement" readonly></mu-switch>
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item button :ripple="false" @click="handleToggle('kinds', 'proposal')" slot="nested">
          <mu-list-item-title>Proposal</mu-list-item-title>
          <mu-list-item-action>
            <mu-switch v-model="kinds.proposal" readonly></mu-switch>
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item button :ripple="false" @click="handleToggle('kinds', 'task')" slot="nested">
          <mu-list-item-title>Task</mu-list-item-title>
          <mu-list-item-action>
            <mu-switch v-model="kinds.task" readonly></mu-switch>
          </mu-list-item-action>
        </mu-list-item>
      </mu-list-item>

      <mu-list-item button :ripple="false" nested :open="open.repos" @toggle-nested="open[repos] = true">
        <mu-list-item-action>
          <mu-icon value="store"></mu-icon>
        </mu-list-item-action>
        <mu-list-item-title>Repos</mu-list-item-title>
        <mu-list-item-action>
          <mu-icon class="toggle-icon" size="24" value="keyboard_arrow_down"></mu-icon>
        </mu-list-item-action>

        <mu-list-item button :ripple="false" @click="isDialogAddRepoOpen = true" slot="nested">
          <mu-list-item-action>
            <mu-icon value="add"></mu-icon>
          </mu-list-item-action>
          <mu-list-item-title>Add</mu-list-item-title>
        </mu-list-item>

        <template v-if="Object.keys(repos).length > 0">
          <mu-list-item v-for="(isSelected, repoName, index) in repos" :key="index" button :ripple="false" @click="handleToggle('repos', repoName)" slot="nested">
            <mu-list-item-action>
              <mu-checkbox v-model="repos[repoName]"  readonly></mu-checkbox>
            </mu-list-item-action>
            <mu-list-item-title>{{repoName}}</mu-list-item-title>
          </mu-list-item>
        </template>
        
      </mu-list-item>
    </mu-list>
    <dialog-add-repo :open.sync="isDialogAddRepoOpen"></dialog-add-repo>
  </div>
</template>

<script>
import DialogAddRepo from './DialogAddRepo.vue'

export default {
  name: 'SideMenu',
  components: {
    DialogAddRepo
  },
  props: {
  },
  data () {
    return {
      timeoutDelay: 360000,
      timeout: null,
      isDialogAddRepoOpen: false,
      open: {
        kinds: false,
        repos: true,
      },
      kinds: {
        bug: true,
        enhancement: false,
        proposal: false,
        task: false,
      },
      repos: {
      }
    }
  },
  created: function() {
    this.refreshData();
  },
  mounted: function() {
    let repos = localStorage.getItem('repos');
    this.repos = repos === null ? {} : JSON.parse(repos);
    this.refreshData();
  },
  methods: {
    addRepo(repoName) {
      this.handleToggle('repos', repoName);
    },
    handleToggle (arr, key) {
      clearTimeout(this.timeout);
      this.$set(this[arr], key, !this[arr][key])
      this.refreshData();
    },
    refreshData() {
      this.$parent.getIssues({
        kinds: Object.keys(this.kinds).filter(item => this.kinds[item]),
        repos: Object.keys(this.repos).filter(item => this.repos[item])
      })
      this.timeout = setTimeout(this.refreshData, this.timeoutDelay);
    }
  },
  watch: {
    repos: function(newRepos) {
      localStorage.setItem('repos', JSON.stringify(newRepos));
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu.vue